export function formatDate(dateString) {
    try {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat().format(date);
    }
    catch (e) {
        return dateString;
    }
}
